import React from 'react'

import './footer.css'

import Link from '../HeaderLink'

const Footer = ((props)=>(
	<div>
		<div className="col">
			<div className="title">{props.contacts.title}</div>
			<div className="address" dangerouslySetInnerHTML={{__html: props.contacts.address}}></div>
			{
				props && props.contacts.links ? props.contacts.links.map((link)=>(
					<Link url={link.url} text={link.caption} target={link.target} key={link.id}/>
				)): '' 
			}
		</div>
		<div className="col">
			<div className="footer__logo">
				<img src={props.logo} alt="Master Vantagem" />
			</div>
			<div>
				{
					props && props.links ? props.links.map((link)=>(
						<Link url={link.url} text={link.caption} target={link.target} key={link.id} />
					)): '' 
				}
			</div>
			{props.disclaimer}
		</div>
		<div className="col">
			<div>
				<div className="title">{props.social.title}</div>
				{
					props && props.social.links ? props.social.links.map((link)=>(
						<Link url={link.url} text={link.caption} target={link.target} icon={link.icon} key={link.id} />
					)): '' 
				}
			</div>
		</div>
	</div>
)) 

export default Footer


// WEBPACK FOOTER //
// ./src/Components/Footer/index.js